import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ children }) => {
  const { token, user } = useSelector((state) => state.auth);
  
  if (token) {
    //  if there is already logged in user redirect to the appropriate page 
    const userRole = user?.user_account_type;
    if (["super_admin", "manager", "editor"].includes(userRole)) {
      return <Navigate to="/admin" />;
    } else if (userRole === "customer") {
      return <Navigate to="/" />;
    }
  }
  return children;
};

export default PublicRoute;